import { useState } from "react";
import AddTodo from "./AddTodo";
import ListTodos from "./ListTodos";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

const Todos = () => {
    const auth = useSelector((state) => state.auth);

    const [ todo, setTodo ] = useState({
        name: "",
        isComplete: false
    });

    if(!auth._id){
        return <Redirect to="/sign-in" />;
    }

    return ( 
        
        <>
            <AddTodo todo={todo} setTodo={setTodo} />
            <ListTodos setTodo={setTodo} />
        </>
     );
}
 
export default Todos;